import {
  throwUninitializedPropertyAccessExceptionyynx7gkm73wd as throwUninitializedPropertyAccessException,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  checkIndexOverflow3frtmheghr0th as checkIndexOverflow,
  copyToArray2j022khrow2yi as copyToArray,
  mapCapacity1h45rc3eh9p2l as mapCapacity,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { equals2au1ep9vhcato as equals } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { HashSet2dzve9y63nf0v as HashSet } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/HashSet.mjs';
import {
  addClass1ihnmxbr5xjr2 as addClass,
  hasClass3787e36stqarb as hasClass,
  removeClass3jnpygopqxh7s as removeClass,
} from '../../../../../kotlin_org_jetbrains_kotlin_kotlin_dom_api_compat/kotlinx/dom/Classes.mjs';
import { isBlank1dvkhjjvox3p0 as isBlank } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import {
  Collection1k04j3hzsbod0 as Collection,
  KtMutableSetwuwn7k5m570a as KtMutableSet,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { NotImplementedErrorfzlkpv14xxr8 as NotImplementedError } from '../../../../../kotlin-kotlin-stdlib/kotlin/Standard.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { json3n35pf5np6si4 as json } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/json.mjs';
import { joinToString1cxrrlmo0chqs as joinToString } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { Default_getInstance3u4i6y54ri5cn as Default_getInstance } from '../../../../../kotlin-kotlin-stdlib/kotlin/random/Random.mjs';
import {
  until1jbpn0z3f8lbg as until,
  coerceAtLeast2bkz8m9ik7hep as coerceAtLeast,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { roundToInt1ue8x8yshtznx as roundToInt } from '../../../../../kotlin-kotlin-stdlib/kotlin/math/math.mjs';
import { get_px1lajc6xaddk2r as get_px } from '../models/data.js.mjs';
import { Dimensions32ju1l7z4mh as Dimension } from '../models/data.mjs';
import { iterator2ui8u8e1d2x5o as iterator } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/dynamic.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import {
  DragData2helsigoeiabk as DragData,
  DragEventn7vmft816tmz as DragEvent,
} from '../models/DragData.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var FutureElement$ClassSet$iterator$1Class;
function FutureElement$ClassSet$iterator$1() {
  if (FutureElement$ClassSet$iterator$1Class === VOID) {
    class $ {
      constructor($index, $list) {
        this.bdp_1 = $index;
        this.cdp_1 = $list;
      }
      n1() {
        return this.bdp_1._v < this.cdp_1.length;
      }
      ddp() {
        var tmp = this.adp_1;
        if (!(tmp == null))
          return tmp;
        else {
          throwUninitializedPropertyAccessException('last');
        }
      }
      o1() {
        var tmp = this;
        var tmp0_elvis_lhs = this.cdp_1.item(this.bdp_1._v);
        tmp.adp_1 = tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
        var _unary__edvuaz = this.bdp_1._v;
        this.bdp_1._v = _unary__edvuaz + 1 | 0;
        return this.ddp();
      }
      l6() {
        this.cdp_1.remove(this.ddp());
        var _unary__edvuaz = this.bdp_1._v;
        this.bdp_1._v = _unary__edvuaz - 1 | 0;
      }
    }
    initMetadataForClass($);
    FutureElement$ClassSet$iterator$1Class = $;
  }
  return FutureElement$ClassSet$iterator$1Class;
}
function _set_element__ae2pkn($this, value) {
  $this.vb3_1 = value;
  var tmp = $this.bb4_1;
  var tmp0_safe_receiver = value instanceof HTMLElement ? value : null;
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.style;
  var tmp_0;
  if (tmp1_elvis_lhs == null) {
    var tmp2_safe_receiver = value instanceof SVGElement ? value : null;
    tmp_0 = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.style;
  } else {
    tmp_0 = tmp1_elvis_lhs;
  }
  tmp.fb7_1 = tmp_0;
  $this.zb3_1.ib7_1 = value;
}
function assertSizeMatch($this) {
  var tmp0_safe_receiver = $this.vb3_1;
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    if (!(tmp0_safe_receiver.childElementCount === $this.lb4_1.p1()))
      throw IllegalStateException().o4('Size mismatch - ' + tmp0_safe_receiver.childElementCount + ' vs ' + $this.lb4_1.p1());
    // Inline function 'kotlin.collections.forEachIndexed' call
    var index = 0;
    var _iterator__ex2g4s = $this.lb4_1.m1();
    while (_iterator__ex2g4s.n1()) {
      var item = _iterator__ex2g4s.o1();
      var _unary__edvuaz = index;
      index = _unary__edvuaz + 1 | 0;
      var index_0 = checkIndexOverflow(_unary__edvuaz);
      if (!equals(item.vb3_1, tmp0_safe_receiver.children.item(index_0))) {
        console.warn('WARNING: Child order inconsistency at index ' + index_0, tmp0_safe_receiver);
      }
    }
  }
}
var ClassSetClass;
function ClassSet() {
  if (ClassSetClass === VOID) {
    class $ {
      constructor($outer) {
        this.fdp_1 = $outer;
        this.edp_1 = HashSet().ha();
      }
      gdp(element) {
        var tmp0_safe_receiver = this.fdp_1.vb3_1;
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : addClass(tmp0_safe_receiver, [element]);
        return tmp1_elvis_lhs == null ? this.edp_1.v(element) : tmp1_elvis_lhs;
      }
      v(element) {
        return this.gdp((!(element == null) ? typeof element === 'string' : false) ? element : THROW_CCE());
      }
      hdp(elements) {
        var tmp0_safe_receiver = this.fdp_1.vb3_1;
        var tmp;
        if (tmp0_safe_receiver == null) {
          tmp = null;
        } else {
          // Inline function 'kotlin.collections.toTypedArray' call
          var tmp$ret$0 = copyToArray(elements);
          tmp = addClass(tmp0_safe_receiver, tmp$ret$0.slice());
        }
        var tmp1_elvis_lhs = tmp;
        return tmp1_elvis_lhs == null ? this.edp_1.r1(elements) : tmp1_elvis_lhs;
      }
      r1(elements) {
        return this.hdp(elements);
      }
      p1() {
        var tmp0_safe_receiver = this.fdp_1.vb3_1;
        var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.classList;
        var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.length;
        return tmp2_elvis_lhs == null ? this.edp_1.p1() : tmp2_elvis_lhs;
      }
      v3() {
        var tmp0_safe_receiver = this.fdp_1.vb3_1;
        var tmp;
        if (tmp0_safe_receiver == null) {
          tmp = null;
        } else {
          // Inline function 'kotlin.let' call
          tmp0_safe_receiver.className = '';
          tmp = Unit_instance;
        }
        var tmp1_elvis_lhs = tmp;
        var tmp_0;
        if (tmp1_elvis_lhs == null) {
          this.edp_1.v3();
          tmp_0 = Unit_instance;
        } else {
          tmp_0 = tmp1_elvis_lhs;
        }
        return tmp_0;
      }
      i1() {
        var tmp0_safe_receiver = this.fdp_1.vb3_1;
        var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.className;
        var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : isBlank(tmp1_safe_receiver);
        return tmp2_elvis_lhs == null ? this.edp_1.i1() : tmp2_elvis_lhs;
      }
      idp(elements) {
        var tmp$ret$0;
        $l$block_0: {
          // Inline function 'kotlin.collections.all' call
          var tmp;
          if (isInterface(elements, Collection())) {
            tmp = elements.i1();
          } else {
            tmp = false;
          }
          if (tmp) {
            tmp$ret$0 = true;
            break $l$block_0;
          }
          var _iterator__ex2g4s = elements.m1();
          while (_iterator__ex2g4s.n1()) {
            var element = _iterator__ex2g4s.o1();
            if (!this.jdp(element)) {
              tmp$ret$0 = false;
              break $l$block_0;
            }
          }
          tmp$ret$0 = true;
        }
        return tmp$ret$0;
      }
      l3(elements) {
        return this.idp(elements);
      }
      jdp(element) {
        var tmp0_safe_receiver = this.fdp_1.vb3_1;
        var tmp;
        if (tmp0_safe_receiver == null) {
          tmp = null;
        } else {
          // Inline function 'kotlin.let' call
          tmp = hasClass(tmp0_safe_receiver, element);
        }
        var tmp1_elvis_lhs = tmp;
        return tmp1_elvis_lhs == null ? this.edp_1.t1(element) : tmp1_elvis_lhs;
      }
      t1(element) {
        if (!(!(element == null) ? typeof element === 'string' : false))
          return false;
        return this.jdp((!(element == null) ? typeof element === 'string' : false) ? element : THROW_CCE());
      }
      m1() {
        var tmp0_safe_receiver = this.fdp_1.vb3_1;
        var tmp;
        if (tmp0_safe_receiver == null) {
          tmp = null;
        } else {
          // Inline function 'kotlin.let' call
          var index = {_v: 0};
          var list = tmp0_safe_receiver.classList;
          tmp = new (FutureElement$ClassSet$iterator$1())(index, list);
        }
        var tmp1_elvis_lhs = tmp;
        return tmp1_elvis_lhs == null ? this.edp_1.m1() : tmp1_elvis_lhs;
      }
      kdp(elements) {
        throw NotImplementedError().qd();
      }
      x3(elements) {
        return this.kdp(elements);
      }
      ldp(element) {
        var tmp0_safe_receiver = this.fdp_1.vb3_1;
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : removeClass(tmp0_safe_receiver, [element]);
        return tmp1_elvis_lhs == null ? this.edp_1.w3(element) : tmp1_elvis_lhs;
      }
      w3(element) {
        if (!(!(element == null) ? typeof element === 'string' : false))
          return false;
        return this.ldp((!(element == null) ? typeof element === 'string' : false) ? element : THROW_CCE());
      }
      mdp(elements) {
        var tmp0_safe_receiver = this.fdp_1.vb3_1;
        var tmp;
        if (tmp0_safe_receiver == null) {
          tmp = null;
        } else {
          // Inline function 'kotlin.collections.toTypedArray' call
          var tmp$ret$0 = copyToArray(elements);
          tmp = removeClass(tmp0_safe_receiver, tmp$ret$0.slice());
        }
        var tmp1_elvis_lhs = tmp;
        return tmp1_elvis_lhs == null ? this.edp_1.w2(elements) : tmp1_elvis_lhs;
      }
      w2(elements) {
        return this.mdp(elements);
      }
    }
    initMetadataForClass($, 'ClassSet', VOID, VOID, [KtMutableSet()]);
    ClassSetClass = $;
  }
  return ClassSetClass;
}
function FutureElement$click$lambda(it) {
  (it instanceof HTMLElement ? it : THROW_CCE()).click();
  return Unit_instance;
}
function FutureElement$focus$lambda(it) {
  (it instanceof HTMLElement ? it : THROW_CCE()).focus();
  return Unit_instance;
}
var FutureElementClass;
function FutureElement() {
  if (FutureElementClass === VOID) {
    class $ {
      constructor() {
        this.ub3_1 = ArrayList().w();
        this.vb3_1 = null;
        this.wb3_1 = null;
        this.xb3_1 = 'tag';
        this.yb3_1 = json([]);
        this.zb3_1 = new (FutureElementAttributes())(this.yb3_1);
        this.ab4_1 = json([]);
        this.bb4_1 = new (FutureElementStyle())(this.ab4_1);
        this.cb4_1 = null;
        this.db4_1 = null;
        this.eb4_1 = json([]);
        this.fb4_1 = json([]);
        this.gb4_1 = json([]);
        this.hb4_1 = new (ClassSet())(this);
        this.ib4_1 = null;
        this.jb4_1 = null;
        this.kb4_1 = null;
        this.lb4_1 = ArrayList().w();
      }
      rb9() {
        return this.vb3_1;
      }
      xdo() {
        var tmp0_safe_receiver = this.vb3_1;
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          return tmp0_safe_receiver;
        }
        var tmp1_safe_receiver = this.wb3_1;
        var tmp;
        if (tmp1_safe_receiver == null) {
          tmp = null;
        } else {
          // Inline function 'kotlin.let' call
          tmp = document.createElementNS(tmp1_safe_receiver, this.xb3_1);
        }
        var tmp2_elvis_lhs = tmp;
        var e = tmp2_elvis_lhs == null ? document.createElement(this.xb3_1) : tmp2_elvis_lhs;
        var tmp3_safe_receiver = this.ib4_1;
        if (tmp3_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          e.id = tmp3_safe_receiver;
        }
        // Inline function 'com.lightningkite.kiteui.views.objectAssign' call
        var source = this.yb3_1;
        Object.assign(e, source);
        var tmp4_safe_receiver = e instanceof HTMLElement ? e : null;
        var tmp5_safe_receiver = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.style;
        var tmp_0;
        if (tmp5_safe_receiver == null) {
          tmp_0 = null;
        } else {
          // Inline function 'kotlin.let' call
          var it = tmp5_safe_receiver;
          // Inline function 'com.lightningkite.kiteui.views.objectAssign' call
          var source_0 = this.ab4_1;
          Object.assign(it, source_0);
          forEach(this.fb4_1, (k, v) => {
            it.setProperty(k, v);
            return Unit_instance;
          });
          tmp_0 = Unit_instance;
        }
        if (tmp_0 == null) {
          var tmp7_safe_receiver = e instanceof SVGElement ? e : null;
          var tmp8_safe_receiver = tmp7_safe_receiver == null ? null : tmp7_safe_receiver.style;
          if (tmp8_safe_receiver == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            var it_0 = tmp8_safe_receiver;
            // Inline function 'com.lightningkite.kiteui.views.objectAssign' call
            var source_1 = this.ab4_1;
            Object.assign(it_0, source_1);
            forEach(this.fb4_1, (k, v) => {
              it_0.setProperty(k, v);
              return Unit_instance;
            });
          }
        }
        forEach(this.gb4_1, (k, v) => {
          e.setAttribute(k, v);
          return Unit_instance;
        });
        var tmp9_safe_receiver = this.jb4_1;
        if (tmp9_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          var tmp0_safe_receiver_0 = e instanceof HTMLElement ? e : null;
          if (tmp0_safe_receiver_0 == null)
            null;
          else {
            tmp0_safe_receiver_0.innerText = tmp9_safe_receiver;
          }
        }
        var tmp10_safe_receiver = this.kb4_1;
        if (tmp10_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          var tmp0_safe_receiver_1 = e instanceof HTMLElement ? e : null;
          if (tmp0_safe_receiver_1 == null)
            null;
          else {
            tmp0_safe_receiver_1.innerHTML = tmp10_safe_receiver;
          }
        }
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s = this.oba().m1();
        while (_iterator__ex2g4s.n1()) {
          var element = _iterator__ex2g4s.o1();
          e.appendChild(element.xdo());
        }
        var tmp_1;
        if ((e instanceof HTMLElement ? e : null) == null) {
          tmp_1 = null;
        } else {
          // Inline function 'kotlin.let' call
          e.className = joinToString(this.hb4_1, ' ');
          tmp_1 = Unit_instance;
        }
        if (tmp_1 == null) {
          // Inline function 'kotlin.run' call
          var tmp_2 = e.classList;
          // Inline function 'kotlin.collections.toTypedArray' call
          var this_0 = this.hb4_1;
          var tmp$ret$20 = copyToArray(this_0);
          (function () {
            var $externalVarargReceiverTmp = tmp_2;
            return $externalVarargReceiverTmp.add.apply($externalVarargReceiverTmp, [].slice.call(tmp$ret$20.slice()));
          }.call(this));
        }
        // Inline function 'com.lightningkite.kiteui.views.objectAssign' call
        var source_2 = this.eb4_1;
        Object.assign(e, source_2);
        _set_element__ae2pkn(this, e);
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s_0 = this.ub3_1.m1();
        while (_iterator__ex2g4s_0.n1()) {
          var element_0 = _iterator__ex2g4s_0.o1();
          element_0(e);
        }
        return e;
      }
      ac9() {
        // Inline function 'com.lightningkite.kiteui.views.FutureElement.onElement' call
        var tmp0_safe_receiver = this.vb3_1;
        var tmp;
        if (tmp0_safe_receiver == null) {
          tmp = null;
        } else {
          // Inline function 'kotlin.let' call
          (tmp0_safe_receiver instanceof HTMLElement ? tmp0_safe_receiver : THROW_CCE()).click();
          tmp = Unit_instance;
        }
        if (tmp == null) {
          this.ub3_1.v(FutureElement$click$lambda);
        }
      }
      pb9() {
        // Inline function 'com.lightningkite.kiteui.views.FutureElement.onElement' call
        var tmp0_safe_receiver = this.vb3_1;
        var tmp;
        if (tmp0_safe_receiver == null) {
          tmp = null;
        } else {
          // Inline function 'kotlin.let' call
          (tmp0_safe_receiver instanceof HTMLElement ? tmp0_safe_receiver : THROW_CCE()).focus();
          tmp = Unit_instance;
        }
        if (tmp == null) {
          this.ub3_1.v(FutureElement$focus$lambda);
        }
      }
      ab9(key, value) {
        var element = this.vb3_1;
        if (element == null) {
          if (value == null) {
            remove(this.fb4_1, key);
          } else {
            this.fb4_1[key] = value;
          }
        } else {
          var tmp0_safe_receiver = element instanceof HTMLElement ? element : null;
          var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.style;
          var tmp;
          if (tmp1_elvis_lhs == null) {
            var tmp2_safe_receiver = element instanceof SVGElement ? element : null;
            tmp = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.style;
          } else {
            tmp = tmp1_elvis_lhs;
          }
          var tmp3_elvis_lhs = tmp;
          var tmp_0;
          if (tmp3_elvis_lhs == null) {
            return Unit_instance;
          } else {
            tmp_0 = tmp3_elvis_lhs;
          }
          var style = tmp_0;
          if (value == null) {
            style.removeProperty(key);
          } else {
            style.setProperty(key, value);
          }
        }
      }
      eb9(key, value) {
        var element = this.vb3_1;
        if (element == null) {
          if (value == null) {
            remove(this.gb4_1, key);
          } else {
            this.gb4_1[key] = value;
          }
        } else {
          if (value == null) {
            element.removeAttribute(key);
          } else {
            element.setAttribute(key, value);
          }
        }
      }
      ndp(value) {
        this.ib4_1 = value;
        var tmp0_safe_receiver = this.vb3_1;
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.id = value == null ? Default_getInstance().ul().toString() : value;
        }
      }
      fbu(value) {
        this.jb4_1 = value;
        if (value == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          var tmp = this.vb3_1;
          var tmp0_safe_receiver = tmp instanceof HTMLElement ? tmp : null;
          if (tmp0_safe_receiver == null)
            null;
          else {
            tmp0_safe_receiver.innerText = value;
          }
        }
      }
      bcp(value) {
        this.kb4_1 = value;
        if (value == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          var tmp = this.vb3_1;
          var tmp0_safe_receiver = tmp instanceof HTMLElement ? tmp : null;
          if (tmp0_safe_receiver == null)
            null;
          else {
            tmp0_safe_receiver.innerHTML = value;
          }
        }
      }
      oba() {
        var tmp0_safe_receiver = this.vb3_1;
        var tmp;
        if (tmp0_safe_receiver == null) {
          tmp = null;
        } else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.let' call
          var it = tmp0_safe_receiver.children;
          // Inline function 'kotlin.collections.map' call
          var this_0 = until(0, it.length);
          // Inline function 'kotlin.collections.mapTo' call
          var destination = ArrayList().u(collectionSizeOrDefault(this_0, 10));
          var inductionVariable = this_0.i2_1;
          var last = this_0.j2_1;
          if (inductionVariable <= last)
            do {
              var item = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var i = item;
              var item_0 = it.item(i);
              // Inline function 'kotlin.collections.find' call
              var tmp0 = this.lb4_1;
              var tmp$ret$1;
              $l$block: {
                // Inline function 'kotlin.collections.firstOrNull' call
                var _iterator__ex2g4s = tmp0.m1();
                while (_iterator__ex2g4s.n1()) {
                  var element = _iterator__ex2g4s.o1();
                  if (element.vb3_1 === item_0) {
                    tmp$ret$1 = element;
                    break $l$block;
                  }
                }
                tmp$ret$1 = null;
              }
              var tmp0_elvis_lhs = tmp$ret$1;
              var tmp_0;
              if (tmp0_elvis_lhs == null) {
                // Inline function 'kotlin.apply' call
                var this_1 = new (FutureElement())();
                _set_element__ae2pkn(this_1, it.item(i));
                tmp_0 = this_1;
              } else {
                tmp_0 = tmp0_elvis_lhs;
              }
              var tmp$ret$5 = tmp_0;
              destination.v(tmp$ret$5);
            }
             while (!(item === last));
          // Inline function 'kotlin.also' call
          this.lb4_1.v3();
          this.lb4_1.r1(destination);
          tmp = destination;
        }
        var tmp1_elvis_lhs = tmp;
        return tmp1_elvis_lhs == null ? this.lb4_1 : tmp1_elvis_lhs;
      }
      zbt(element) {
        assertSizeMatch(this);
        this.lb4_1.v(element);
        var tmp0_safe_receiver = this.vb3_1;
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          tmp0_safe_receiver.appendChild(element.xdo());
        }
        assertSizeMatch(this);
      }
      vb9(index, element) {
        assertSizeMatch(this);
        if (index > this.lb4_1.p1())
          throw IllegalStateException().kd();
        this.lb4_1.y3(index, element);
        var tmp0_safe_receiver = this.vb3_1;
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          var tmp0_safe_receiver_0 = tmp0_safe_receiver.children.item(index);
          var tmp;
          if (tmp0_safe_receiver_0 == null) {
            tmp = null;
          } else {
            // Inline function 'kotlin.let' call
            tmp = tmp0_safe_receiver.insertBefore(element.xdo(), tmp0_safe_receiver_0);
          }
          tmp == null && tmp0_safe_receiver.appendChild(element.xdo());
        }
        assertSizeMatch(this);
      }
      xb9(index) {
        assertSizeMatch(this);
        this.lb4_1.z3(index);
        var tmp0_safe_receiver = this.vb3_1;
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          var tmp0_safe_receiver_0 = tmp0_safe_receiver.children.item(index);
          var tmp;
          if (tmp0_safe_receiver_0 == null) {
            tmp = null;
          } else {
            // Inline function 'kotlin.let' call
            tmp = tmp0_safe_receiver.removeChild(tmp0_safe_receiver_0);
          }
        }
        assertSizeMatch(this);
      }
      zb9() {
        assertSizeMatch(this);
        this.lb4_1.v3();
        var tmp0_safe_receiver = this.vb3_1;
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.innerHTML = '';
        }
        assertSizeMatch(this);
      }
    }
    initMetadataForClass($, 'FutureElement', FutureElement);
    FutureElementClass = $;
  }
  return FutureElementClass;
}
var FutureElementStyleClass;
function FutureElementStyle() {
  if (FutureElementStyleClass === VOID) {
    class $ {
      constructor(native) {
        this.fb7_1 = native;
      }
    }
    initMetadataForClass($, 'FutureElementStyle');
    FutureElementStyleClass = $;
  }
  return FutureElementStyleClass;
}
var FutureElementAttributesClass;
function FutureElementAttributes() {
  if (FutureElementAttributesClass === VOID) {
    class $ {
      constructor(native) {
        this.ib7_1 = native;
      }
    }
    initMetadataForClass($, 'FutureElementAttributes');
    FutureElementAttributesClass = $;
  }
  return FutureElementAttributesClass;
}
function nativeSetDragData(_this__u8e3s4, data) {
  // Inline function 'com.lightningkite.kiteui.views.FutureElement.onElement' call
  var this_0 = _this__u8e3s4.tb5_1;
  var tmp0_safe_receiver = this_0.vb3_1;
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    if (!(data == null)) {
      var tmp_0 = tmp0_safe_receiver instanceof HTMLElement ? tmp0_safe_receiver : THROW_CCE();
      tmp_0.ondragstart = (event) => {
        event.stopPropagation();
        // Inline function 'kotlin.collections.iterator' call
        var _iterator__ex2g4s = data.acy_1.d2().m1();
        while (_iterator__ex2g4s.n1()) {
          var _destruct__k2r9zo = _iterator__ex2g4s.o1();
          // Inline function 'kotlin.collections.component1' call
          var type = _destruct__k2r9zo.e2();
          // Inline function 'kotlin.collections.component2' call
          var value = _destruct__k2r9zo.f2();
          ensureNotNull(event.dataTransfer).setData(type, value);
          var tmp0_safe_receiver = data.bcy_1;
          if (tmp0_safe_receiver == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            // Inline function 'com.lightningkite.kiteui.views.FutureElement.onElement' call
            var this_0 = tmp0_safe_receiver.gcy_1.tb5_1;
            var tmp0_safe_receiver_0 = this_0.vb3_1;
            var tmp;
            if (tmp0_safe_receiver_0 == null) {
              tmp = null;
            } else {
              // Inline function 'kotlin.let' call
              var tmp_0 = ensureNotNull(event.dataTransfer);
              var tmp_1;
              switch (tmp0_safe_receiver.hcy_1.b4_1) {
                case 0:
                  tmp_1 = 0;
                  break;
                case 1:
                case 3:
                  tmp_1 = roundToInt(tmp0_safe_receiver_0.getBoundingClientRect().width / 2);
                  break;
                case 2:
                  tmp_1 = roundToInt(tmp0_safe_receiver_0.getBoundingClientRect().width);
                  break;
                default:
                  noWhenBranchMatchedException();
                  break;
              }
              var tmp_2 = tmp_1;
              var tmp1_safe_receiver = tmp0_safe_receiver.jcy_1;
              var tmp_3;
              var tmp_4 = tmp1_safe_receiver;
              if ((tmp_4 == null ? null : new (Dimension())(tmp_4)) == null) {
                tmp_3 = null;
              } else {
                tmp_3 = get_px(tmp1_safe_receiver);
              }
              var tmp2_safe_receiver = tmp_3;
              var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : roundToInt(tmp2_safe_receiver);
              var tmp_5 = tmp_2 + (tmp3_elvis_lhs == null ? 0 : tmp3_elvis_lhs) | 0;
              var tmp_6;
              switch (tmp0_safe_receiver.icy_1.b4_1) {
                case 0:
                  tmp_6 = 0;
                  break;
                case 1:
                case 3:
                  tmp_6 = roundToInt(tmp0_safe_receiver_0.getBoundingClientRect().height / 2);
                  break;
                case 2:
                  tmp_6 = roundToInt(tmp0_safe_receiver_0.getBoundingClientRect().height);
                  break;
                default:
                  noWhenBranchMatchedException();
                  break;
              }
              var tmp_7 = tmp_6;
              var tmp5_safe_receiver = tmp0_safe_receiver.kcy_1;
              var tmp_8;
              var tmp_9 = tmp5_safe_receiver;
              if ((tmp_9 == null ? null : new (Dimension())(tmp_9)) == null) {
                tmp_8 = null;
              } else {
                tmp_8 = get_px(tmp5_safe_receiver);
              }
              var tmp6_safe_receiver = tmp_8;
              var tmp7_elvis_lhs = tmp6_safe_receiver == null ? null : roundToInt(tmp6_safe_receiver);
              tmp_0.setDragImage(tmp0_safe_receiver_0, tmp_5, tmp_7 + (tmp7_elvis_lhs == null ? 0 : tmp7_elvis_lhs) | 0);
              tmp = Unit_instance;
            }
            if (tmp == null) {
              this_0.ub3_1.v(nativeSetDragData$lambda$lambda(event, tmp0_safe_receiver));
            }
          }
        }
        return Unit_instance;
      };
    } else {
      (tmp0_safe_receiver instanceof HTMLElement ? tmp0_safe_receiver : THROW_CCE()).ondragstart = null;
      tmp0_safe_receiver.ondragend = null;
    }
    tmp = Unit_instance;
  }
  if (tmp == null) {
    this_0.ub3_1.v((it) => {
      if (!(data == null)) {
        var tmp = it instanceof HTMLElement ? it : THROW_CCE();
        tmp.ondragstart = (event) => {
          event.stopPropagation();
          // Inline function 'kotlin.collections.iterator' call
          var _iterator__ex2g4s = data.acy_1.d2().m1();
          while (_iterator__ex2g4s.n1()) {
            var _destruct__k2r9zo = _iterator__ex2g4s.o1();
            // Inline function 'kotlin.collections.component1' call
            var type = _destruct__k2r9zo.e2();
            // Inline function 'kotlin.collections.component2' call
            var value = _destruct__k2r9zo.f2();
            ensureNotNull(event.dataTransfer).setData(type, value);
            var tmp0_safe_receiver = data.bcy_1;
            if (tmp0_safe_receiver == null)
              null;
            else {
              // Inline function 'kotlin.let' call
              // Inline function 'com.lightningkite.kiteui.views.FutureElement.onElement' call
              var this_0 = tmp0_safe_receiver.gcy_1.tb5_1;
              var tmp0_safe_receiver_0 = this_0.vb3_1;
              var tmp;
              if (tmp0_safe_receiver_0 == null) {
                tmp = null;
              } else {
                // Inline function 'kotlin.let' call
                var tmp_0 = ensureNotNull(event.dataTransfer);
                var tmp_1;
                switch (tmp0_safe_receiver.hcy_1.b4_1) {
                  case 0:
                    tmp_1 = 0;
                    break;
                  case 1:
                  case 3:
                    tmp_1 = roundToInt(tmp0_safe_receiver_0.getBoundingClientRect().width / 2);
                    break;
                  case 2:
                    tmp_1 = roundToInt(tmp0_safe_receiver_0.getBoundingClientRect().width);
                    break;
                  default:
                    noWhenBranchMatchedException();
                    break;
                }
                var tmp_2 = tmp_1;
                var tmp1_safe_receiver = tmp0_safe_receiver.jcy_1;
                var tmp_3;
                var tmp_4 = tmp1_safe_receiver;
                if ((tmp_4 == null ? null : new (Dimension())(tmp_4)) == null) {
                  tmp_3 = null;
                } else {
                  tmp_3 = get_px(tmp1_safe_receiver);
                }
                var tmp2_safe_receiver = tmp_3;
                var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : roundToInt(tmp2_safe_receiver);
                var tmp_5 = tmp_2 + (tmp3_elvis_lhs == null ? 0 : tmp3_elvis_lhs) | 0;
                var tmp_6;
                switch (tmp0_safe_receiver.icy_1.b4_1) {
                  case 0:
                    tmp_6 = 0;
                    break;
                  case 1:
                  case 3:
                    tmp_6 = roundToInt(tmp0_safe_receiver_0.getBoundingClientRect().height / 2);
                    break;
                  case 2:
                    tmp_6 = roundToInt(tmp0_safe_receiver_0.getBoundingClientRect().height);
                    break;
                  default:
                    noWhenBranchMatchedException();
                    break;
                }
                var tmp_7 = tmp_6;
                var tmp5_safe_receiver = tmp0_safe_receiver.kcy_1;
                var tmp_8;
                var tmp_9 = tmp5_safe_receiver;
                if ((tmp_9 == null ? null : new (Dimension())(tmp_9)) == null) {
                  tmp_8 = null;
                } else {
                  tmp_8 = get_px(tmp5_safe_receiver);
                }
                var tmp6_safe_receiver = tmp_8;
                var tmp7_elvis_lhs = tmp6_safe_receiver == null ? null : roundToInt(tmp6_safe_receiver);
                tmp_0.setDragImage(tmp0_safe_receiver_0, tmp_5, tmp_7 + (tmp7_elvis_lhs == null ? 0 : tmp7_elvis_lhs) | 0);
                tmp = Unit_instance;
              }
              if (tmp == null) {
                this_0.ub3_1.v(nativeSetDragData$lambda$lambda$lambda(event, tmp0_safe_receiver));
              }
            }
          }
          return Unit_instance;
        };
      } else {
        (it instanceof HTMLElement ? it : THROW_CCE()).ondragstart = null;
        it.ondragend = null;
      }
      return Unit_instance;
    });
  }
}
function nativeOnDrop(_this__u8e3s4, listener) {
  // Inline function 'com.lightningkite.kiteui.views.FutureElement.onElement' call
  var this_0 = _this__u8e3s4.tb5_1;
  var tmp0_safe_receiver = this_0.vb3_1;
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    if (!(listener == null)) {
      if (!(tmp0_safe_receiver instanceof HTMLElement))
        THROW_CCE();
      tmp0_safe_receiver.ondragover = (e) => {
        var tmp;
        if (listener.qd8(nativeOnDrop$toDragEvent(e))) {
          e.preventDefault();
          e.stopPropagation();
          tmp = Unit_instance;
        }
        return Unit_instance;
      };
      tmp0_safe_receiver.ondragenter = (e) => {
        var tmp;
        if (listener.rd8(nativeOnDrop$toDragEvent(e))) {
          e.preventDefault();
          e.stopPropagation();
          tmp = Unit_instance;
        }
        return Unit_instance;
      };
      tmp0_safe_receiver.ondragleave = (e) => {
        var tmp;
        if (listener.sd8(nativeOnDrop$toDragEvent(e))) {
          e.preventDefault();
          e.stopPropagation();
          tmp = Unit_instance;
        }
        return Unit_instance;
      };
      tmp0_safe_receiver.ondragend = (e) => {
        var tmp;
        if (listener.td8(nativeOnDrop$toDragEvent(e))) {
          e.preventDefault();
          e.stopPropagation();
          tmp = Unit_instance;
        }
        return Unit_instance;
      };
      tmp0_safe_receiver.ondrop = (e) => {
        var tmp;
        if (listener.ud8(nativeOnDrop$toDragEvent(e))) {
          e.preventDefault();
          e.stopPropagation();
          tmp = Unit_instance;
        }
        return Unit_instance;
      };
    } else {
      (tmp0_safe_receiver instanceof HTMLElement ? tmp0_safe_receiver : THROW_CCE()).ondragover = null;
      tmp0_safe_receiver.ondragenter = null;
      tmp0_safe_receiver.ondragleave = null;
      tmp0_safe_receiver.ondragexit = null;
      tmp0_safe_receiver.ondrop = null;
    }
    tmp = Unit_instance;
  }
  if (tmp == null) {
    this_0.ub3_1.v((it) => {
      if (!(listener == null)) {
        if (!(it instanceof HTMLElement))
          THROW_CCE();
        it.ondragover = (e) => {
          var tmp;
          if (listener.qd8(nativeOnDrop$toDragEvent(e))) {
            e.preventDefault();
            e.stopPropagation();
            tmp = Unit_instance;
          }
          return Unit_instance;
        };
        it.ondragenter = (e) => {
          var tmp;
          if (listener.rd8(nativeOnDrop$toDragEvent(e))) {
            e.preventDefault();
            e.stopPropagation();
            tmp = Unit_instance;
          }
          return Unit_instance;
        };
        it.ondragleave = (e) => {
          var tmp;
          if (listener.sd8(nativeOnDrop$toDragEvent(e))) {
            e.preventDefault();
            e.stopPropagation();
            tmp = Unit_instance;
          }
          return Unit_instance;
        };
        it.ondragend = (e) => {
          var tmp;
          if (listener.td8(nativeOnDrop$toDragEvent(e))) {
            e.preventDefault();
            e.stopPropagation();
            tmp = Unit_instance;
          }
          return Unit_instance;
        };
        it.ondrop = (e) => {
          var tmp;
          if (listener.ud8(nativeOnDrop$toDragEvent(e))) {
            e.preventDefault();
            e.stopPropagation();
            tmp = Unit_instance;
          }
          return Unit_instance;
        };
      } else {
        (it instanceof HTMLElement ? it : THROW_CCE()).ondragover = null;
        it.ondragenter = null;
        it.ondragleave = null;
        it.ondragexit = null;
        it.ondrop = null;
      }
      return Unit_instance;
    });
  }
}
function nativeScrollIntoView(_this__u8e3s4, horizontal, vertical, animate) {
  var tmp0_safe_receiver = _this__u8e3s4.tb5_1.vb3_1;
  if (tmp0_safe_receiver == null)
    null;
  else {
    var tmp0 = logicalPosition(vertical);
    var tmp2 = logicalPosition(horizontal);
    var tmp;
    if (animate) {
      // Inline function 'org.w3c.dom.SMOOTH' call
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.unsafeCast' call
      tmp = 'smooth';
    } else {
      // Inline function 'org.w3c.dom.INSTANT' call
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.unsafeCast' call
      tmp = 'instant';
    }
    // Inline function 'org.w3c.dom.ScrollIntoViewOptions' call
    var behavior = tmp;
    var o = {};
    o['block'] = tmp0;
    o['inline'] = tmp2;
    o['behavior'] = behavior;
    tmp0_safe_receiver.scrollIntoView(o);
  }
}
function forEach(receiver, action) {
  var _iterator__ex2g4s = iterator(Object.keys(receiver));
  while (_iterator__ex2g4s.n1()) {
    var key = _iterator__ex2g4s.o1();
    action(key, receiver[key]);
  }
}
function remove(receiver, key) {
  delete receiver[key];
}
function logicalPosition(_this__u8e3s4) {
  var tmp;
  switch (_this__u8e3s4 == null ? -1 : _this__u8e3s4.b4_1) {
    case 0:
      // Inline function 'org.w3c.dom.START' call

      // Inline function 'kotlin.js.asDynamic' call

      // Inline function 'kotlin.js.unsafeCast' call

      tmp = 'start';
      break;
    case 1:
      // Inline function 'org.w3c.dom.CENTER' call

      // Inline function 'kotlin.js.asDynamic' call

      // Inline function 'kotlin.js.unsafeCast' call

      tmp = 'center';
      break;
    case 2:
      // Inline function 'org.w3c.dom.END' call

      // Inline function 'kotlin.js.asDynamic' call

      // Inline function 'kotlin.js.unsafeCast' call

      tmp = 'end';
      break;
    case 3:
      // Inline function 'org.w3c.dom.START' call

      // Inline function 'kotlin.js.asDynamic' call

      // Inline function 'kotlin.js.unsafeCast' call

      tmp = 'start';
      break;
    case -1:
      // Inline function 'org.w3c.dom.NEAREST' call

      // Inline function 'kotlin.js.asDynamic' call

      // Inline function 'kotlin.js.unsafeCast' call

      tmp = 'nearest';
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
}
function nativeOnDrop$toDragEvent(_this__u8e3s4) {
  // Inline function 'kotlin.collections.associate' call
  var this_0 = ensureNotNull(_this__u8e3s4.dataTransfer).types;
  var capacity = coerceAtLeast(mapCapacity(this_0.length), 16);
  // Inline function 'kotlin.collections.associateTo' call
  var destination = LinkedHashMap().fc(capacity);
  var inductionVariable = 0;
  var last = this_0.length;
  while (inductionVariable < last) {
    var element = this_0[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    // Inline function 'kotlin.collections.plusAssign' call
    var pair = to(element, ensureNotNull(_this__u8e3s4.dataTransfer).getData(element));
    destination.s3(pair.af_1, pair.bf_1);
  }
  return new (DragEvent())(DragData().ccy('', destination), _this__u8e3s4.x, _this__u8e3s4.y);
}
function nativeSetDragData$lambda$lambda($event, $shadow) {
  return (it) => {
    var tmp = ensureNotNull($event.dataTransfer);
    var tmp_0;
    switch ($shadow.hcy_1.b4_1) {
      case 0:
        tmp_0 = 0;
        break;
      case 1:
      case 3:
        tmp_0 = roundToInt(it.getBoundingClientRect().width / 2);
        break;
      case 2:
        tmp_0 = roundToInt(it.getBoundingClientRect().width);
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    var tmp_1 = tmp_0;
    var tmp1_safe_receiver = $shadow.jcy_1;
    var tmp_2;
    var tmp_3 = tmp1_safe_receiver;
    if ((tmp_3 == null ? null : new (Dimension())(tmp_3)) == null) {
      tmp_2 = null;
    } else {
      tmp_2 = get_px(tmp1_safe_receiver);
    }
    var tmp2_safe_receiver = tmp_2;
    var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : roundToInt(tmp2_safe_receiver);
    var tmp_4 = tmp_1 + (tmp3_elvis_lhs == null ? 0 : tmp3_elvis_lhs) | 0;
    var tmp_5;
    switch ($shadow.icy_1.b4_1) {
      case 0:
        tmp_5 = 0;
        break;
      case 1:
      case 3:
        tmp_5 = roundToInt(it.getBoundingClientRect().height / 2);
        break;
      case 2:
        tmp_5 = roundToInt(it.getBoundingClientRect().height);
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    var tmp_6 = tmp_5;
    var tmp5_safe_receiver = $shadow.kcy_1;
    var tmp_7;
    var tmp_8 = tmp5_safe_receiver;
    if ((tmp_8 == null ? null : new (Dimension())(tmp_8)) == null) {
      tmp_7 = null;
    } else {
      tmp_7 = get_px(tmp5_safe_receiver);
    }
    var tmp6_safe_receiver = tmp_7;
    var tmp7_elvis_lhs = tmp6_safe_receiver == null ? null : roundToInt(tmp6_safe_receiver);
    tmp.setDragImage(it, tmp_4, tmp_6 + (tmp7_elvis_lhs == null ? 0 : tmp7_elvis_lhs) | 0);
    return Unit_instance;
  };
}
function nativeSetDragData$lambda$lambda$lambda($event, $shadow) {
  return (it) => {
    var tmp = ensureNotNull($event.dataTransfer);
    var tmp_0;
    switch ($shadow.hcy_1.b4_1) {
      case 0:
        tmp_0 = 0;
        break;
      case 1:
      case 3:
        tmp_0 = roundToInt(it.getBoundingClientRect().width / 2);
        break;
      case 2:
        tmp_0 = roundToInt(it.getBoundingClientRect().width);
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    var tmp_1 = tmp_0;
    var tmp1_safe_receiver = $shadow.jcy_1;
    var tmp_2;
    var tmp_3 = tmp1_safe_receiver;
    if ((tmp_3 == null ? null : new (Dimension())(tmp_3)) == null) {
      tmp_2 = null;
    } else {
      tmp_2 = get_px(tmp1_safe_receiver);
    }
    var tmp2_safe_receiver = tmp_2;
    var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : roundToInt(tmp2_safe_receiver);
    var tmp_4 = tmp_1 + (tmp3_elvis_lhs == null ? 0 : tmp3_elvis_lhs) | 0;
    var tmp_5;
    switch ($shadow.icy_1.b4_1) {
      case 0:
        tmp_5 = 0;
        break;
      case 1:
      case 3:
        tmp_5 = roundToInt(it.getBoundingClientRect().height / 2);
        break;
      case 2:
        tmp_5 = roundToInt(it.getBoundingClientRect().height);
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    var tmp_6 = tmp_5;
    var tmp5_safe_receiver = $shadow.kcy_1;
    var tmp_7;
    var tmp_8 = tmp5_safe_receiver;
    if ((tmp_8 == null ? null : new (Dimension())(tmp_8)) == null) {
      tmp_7 = null;
    } else {
      tmp_7 = get_px(tmp5_safe_receiver);
    }
    var tmp6_safe_receiver = tmp_7;
    var tmp7_elvis_lhs = tmp6_safe_receiver == null ? null : roundToInt(tmp6_safe_receiver);
    tmp.setDragImage(it, tmp_4, tmp_6 + (tmp7_elvis_lhs == null ? 0 : tmp7_elvis_lhs) | 0);
    return Unit_instance;
  };
}
//region block: exports
export {
  FutureElement as FutureElement3o36ukl4wk2br,
  nativeOnDrop as nativeOnDropqd3pwmgl0tbk,
  nativeScrollIntoView as nativeScrollIntoView1kvjsy2ddtc83,
  nativeSetDragData as nativeSetDragDatar0aostqx6mw0,
};
//endregion

//# sourceMappingURL=RView.commonHtml.js.mjs.map
